import Resource from 'components/global/Resource'
import { Col, Row } from 'components/grid'
import { StarterKitQueryNode } from 'components/intervention/IRLAStarterKits'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
	data: StarterKitQueryNode
	type: 'irla' | 'enil'
	showFrameworks?: boolean
}

export default function StarterKit({ data, type, showFrameworks }: Props) {
	return (
		<>
			<Row className="my-6" center>
				<Col width="w-1/2 md:w-4/12">
					{type === 'irla' ? (
						<div className="flex h-full flex-col">
							<div className="flex">
								<Resource title="IRLA" noLink noZoom protected={showFrameworks} />
								<div className="-ml-28">
									<Resource title="MLL Guide" noLink noZoom protected={showFrameworks} />
								</div>
							</div>
							<div className="mt-auto pt-4">
								<span className="inline-block w-full text-center text-xl font-semibold">IRLA Framework & Guide to IRLA Coaching with Multilingual Learners</span>
							</div>
						</div>
					) : (
						<div className="flex h-full flex-col">
							<Resource title="ENIL | CCSS" noLink noZoom protected={showFrameworks} />
							<div className="mt-auto pt-4">
								<span className="inline-block w-full text-center text-xl font-semibold">ENIL Framework</span>
							</div>
						</div>
					)}
				</Col>
				<Col width="w-1/2 md:w-4/12">
					<GatsbyImage image={data.node.skillsCards.gatsbyImageData} alt={data.node.skillsCards.title} />
					<div className="mt-auto pt-4">
						<span className="inline-block w-full text-center text-xl font-semibold">Take-Home Reading Skills Cards</span>
					</div>
				</Col>
			</Row>
			<Row center>
				{data.node.baskets.map((b) => {
					return (
						<Col key={b.id} width="w-1/6" gutter="none">
							<GatsbyImage image={b.gatsbyImageData} alt={b.title} />
						</Col>
					)
				})}
			</Row>
			<div className="mt-auto pt-4">
				<span className="inline-block w-full text-center text-xl font-semibold">Classroom Library</span>
			</div>
		</>
	)
}
